import actions from "./actions";

const {
    FETCH_ADMISSION_SLIDES,
    FETCH_ADMISSION_SLIDE,
    RESET_ADMISSION_SLIDE
} = actions;

const initState = {
    admissionSlides: {
        page: 0,
        perPage: 35,
        data: [],
        total: 0
    },
    admissionSlide: { _id: null }
};

const AdmissionSlideReducer = (state = initState, action) => {
    const { type, data } = action;
    switch (type) {
        case FETCH_ADMISSION_SLIDES:
            return {
                ...state,
                admissionSlides: data
            };
        case RESET_ADMISSION_SLIDE:
            return {
                ...state,
                admissionSlide: initState.admissionSlide
            };
        case FETCH_ADMISSION_SLIDE:
            return {
                ...state,
                admissionSlide: data
            };
        default:
            return state;
    }
};

export default AdmissionSlideReducer;
